import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import './search.css';
import searchicon from "../../../images/search.svg";

const Search = forwardRef((props, ref) => {
  const [search, setSearch] = useState('');

  const handleInputChange = (event) => {
    setSearch(event.target.value);
    if (props.onChange) {
      props.onChange(event.target.value);
    }
  };

  return (
    <div className="searchE mt-2 sm:mt-0 sm:self-end" style={{ minWidth: "fit-content" }}>
      <input
        type="text"
        className='fontsearch'
        placeholder={props.placeholder}
        value={search}
        onChange={handleInputChange}
        ref={ref}
      />
      <img src={searchicon} alt="search" style={{ width: 14 }} />
    </div>
  );
})

Search.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Search;